import { PROFILE_TYPES } from '@/models/AccountProfile'
import { CARD_HOLDER_TYPES } from '@/models/CardOrder'

export function getCardHolderTypeLabel (profileType, holderType) {
  if (profileType === PROFILE_TYPES.LEGAL) {
    return ({
      [CARD_HOLDER_TYPES.OTHER]: 'Employee',
      [CARD_HOLDER_TYPES.OWNER]: 'Company representative'
    })[holderType]
  }

  return ({
    [CARD_HOLDER_TYPES.OTHER]: 'Authorized person',
    [CARD_HOLDER_TYPES.OWNER]: 'Client',
    [CARD_HOLDER_TYPES.RELATIVE]: 'Other person'
  })[holderType]
}

export function getCardHolderTypeOptions (profileType) {
  const cardHolderTypes = [CARD_HOLDER_TYPES.OWNER, CARD_HOLDER_TYPES.OTHER]

  if (profileType !== PROFILE_TYPES.LEGAL) {
    cardHolderTypes.push(CARD_HOLDER_TYPES.RELATIVE)
  }

  return cardHolderTypes.map(type => ({ name: getCardHolderTypeLabel(profileType, type), value: type }))
}

export function cardOrderToFormData (cardOrder, profile, profileAccounts) {
  const formData = {
    feeAccountId: null,
    feeCurrency: null
  }

  const currentFeeAccount = profileAccounts.find(
    ({ accountId }) => cardOrder.feeAccountId === accountId
  )

  if (currentFeeAccount != null) {
    Object.assign(formData, {
      feeAccountId: cardOrder.feeAccountId,
      feeCurrency: cardOrder.feeCurrency
    })
  }

  if (cardOrder.isRealCardType) {
    Object.assign(formData, {
      addressCountry: cardOrder.addressCountry,
      addressCity: cardOrder.addressCity,
      addressStreet: cardOrder.addressStreet,
      addressZipCode: cardOrder.addressZipCode,
      disableDeliveryFee: cardOrder.disableDeliveryFee,
      shipmentType: cardOrder.shipmentType,
      recipientFirstName: cardOrder.recipientFirstName,
      recipientLastName: cardOrder.recipientLastName,
      recipientMobilePhone: cardOrder.recipientMobilePhone
    })
  }

  if (cardOrder.isInitializedRenew) {
    return formData
  }

  if (cardOrder.isRealCardType && profile.isLegal) {
    Object.assign(formData, {
      companyName: cardOrder.companyName,
      nameOnCard: cardOrder.nameOnCard
    })
  }

  return {
    ...formData,
    holderFirstName: cardOrder.holderFirstName,
    holderLastName: cardOrder.holderLastName,
    holderMobilePhone: cardOrder.holderMobilePhone,
    avsAddressCountry: cardOrder.avsAddressCountry,
    avsAddressCity: cardOrder.avsAddressCity,
    avsAddressStreet: cardOrder.avsAddressStreet,
    avsAddressZipCode: cardOrder.avsAddressZipCode
  }
}
